import ActiveFilterBar from './ActiveFilterBar';

export default ActiveFilterBar;

export type { IActiveFilterBarProps, IActiveFilterChip } from './ActiveFilterBar';
